/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../../common/components/layout/Layout';
import Header from '../../../../../common/components/layout/Header';
import LayoutInside from '../../../../../common/components/layout/LayoutInside';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDefyById, joinDefy, resetStateDefyResponse } from '../../../../../modules/sport/actions/reducerDefy';
import Loading from '../../../../../common/loading/Loading';
import { format } from 'date-fns';
import Copy from '../../../../../common/components/sections/Copy';
import MsjSuccess from '../../../../../common/components/sections/MsjSuccessDefy';
import { attributesBySport } from '../../../../../common/data/attributes';
import { useAuth } from '../../../../../context/auth-context';
import PaymentLabels from '../../../../../common/components/modules/sports/PaymentLabelsLeft';
import { formatPrice } from '../../../../../utils';
import { ITeam } from '../../../../../modules/sport/interfaces/game';
import FormCreateTeam from '../../../../../common/components/sections/FormCreateTeam';
import { teamProfileGet } from '../../../../../modules/sport/actions/reducerTeam';
import Image from '../../../../../common/Image';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Challenge = (): JSX.Element => {
    const auth = useAuth();

    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const [title, setTitle] = useState<string>();
    const [error, setError] = useState<string>('');
    const challengeId = query.get('challengeId');
    const selectDefy = (state: any) => state.defy;
    const defy = useSelector(selectDefy);
    const selectDefyResponse = (state: any) => state.defyResponse;
    const defyResponse = useSelector(selectDefyResponse);
    const [detDefy, setDetDefy] = useState<any | null>(null);
    const [statusCancel, setStatusCancel] = useState(false);
    const [statusDefy, setStatusDefy] = useState(false);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const week = query.get('week');
    const region = query.get('region');
    const commune = query.get('commune');
    const teamIdRankingFilter = query.get('teamIdRankingFilter');
    const teamNameRankingFilter = query.get('teamNameRankingFilter');
    const [timeDefy, setTimeDefy] = useState(false);
    const mydate = new Date();
    const [errorDefy, setErrorDefy] = useState<string>('');
    const [msj, setMsj] = useState<string>('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [deposit, setDeposit] = useState<number>();
    const selectTeam = (state: any) => state.team;
    const team = useSelector(selectTeam);
    const [openModalTeam, setOpenModalTeam] = useState(false);
    const [dataTeamOri, setdataTeamOri] = useState<ITeam>();
    const typeTeam = query.get('team');
    const pathnameDefys = `/${sport}/desafiar/equipos/filter`;
    const pathnameAll = window.location.pathname + useLocation().search;
    const history = useHistory();
    const [disabledButtonConfirmDefy, setDisabledButtonConfirmDefy] = useState(false);

    const [breads, setBreads] = useState([
        {
            key: 'desafiar',
            name: 'Desafíar | Buscar',
            url: `/desafiar`,
            add: true,
        },
        {
            key: 'equipos',
            name: 'Equipos',
            url: pathnameDefys,
            add: false,
        },
        {
            key: 'confirmar',
            name: 'Confirmar',
            url: pathnameAll,
            add: false,
        },
    ]);

    useEffect(() => {
        setDetDefy(null);
        dispatch(resetStateDefyResponse());
        dispatch(fetchDefyById(challengeId, auth.isLoggedIn, team));
    }, [challengeId]);

    useEffect(() => {
        if (week || region || commune) {
            const pathQuery = `?region=${region}&commune=${commune}&week=${week}`;

            const pathnameDefys = `/${sport}/desafiar/equipos/filter${(week || region || commune) && pathQuery}`;

            setBreads([
                {
                    key: 'desafiar',
                    name: 'Desafíar | Buscar',
                    url: `/desafiar`,
                    add: true,
                },
                {
                    key: 'equipos',
                    name: 'Equipos',
                    url: pathnameDefys,
                    add: false,
                },
                {
                    key: 'confirmar',
                    name: 'Confirmar',
                    url: pathnameAll,
                    add: false,
                },
            ]);
        }
    }, [week, region, commune]);

    useEffect(() => {
        if (defy) {
            if (defy.error) {
                console.log('aqui error');
                setErrorDefy('Error al obtener los recursos para este desafío');
            } else if (defy.data && defy.data.data && defy.data.statusCode === 'CHALLENGES_BY_ID') {
                //console.log(defy.data.data);
                setStatusCancel(false);
                const newDefy = defy.data.data;
                setDetDefy(newDefy);
                setStatusDefy(
                    (newDefy &&
                        dataTeamOri &&
                        Object.keys(newDefy.challengerTeam).some((x) => x === 'id') &&
                        newDefy.challengerTeam?.id === dataTeamOri?.id) ||
                        (Object.keys(newDefy.challengedTeam).some((x) => x === 'id') &&
                            newDefy.challengedTeam?.id === dataTeamOri?.id),
                );
            }
        }
    }, [defy]);

    useEffect(() => {
        //AQUI CAPTURAR ERROR
        if (defyResponse) {
            if (defyResponse.error) {
                setError(defyResponse.error);
            } else if (defyResponse.data) {
                setDisabledButtonConfirmDefy(false);
                //console.log('defyResponse.data en confirmar desafío', defyResponse.data);
                if (defyResponse.data.statusCode === 'CHALLENGES_JOINED_SUCCESS') {
                    setStatusDefy(true);
                    if (defyResponse.data.statusCode === 'CHALLENGES_JOINED_SUCCESS') {
                        setStatusDefy(true);
                        if (
                            (!Object.keys(detDefy.challengerTeam).some((x) => x === 'id') ||
                                !Object.keys(detDefy.challengedTeam).some((x) => x === 'id')) &&
                            detDefy?.reservation?.discountPercentage > 0
                        ) {
                            history.push(`/${sport}/desafiar/pago/filter?challengeId=${detDefy.id}`);
                        }
                    }
                }
            }
        }
    }, [defyResponse]);

    useEffect(() => {
        dispatch(resetStateDefyResponse());
        if (detDefy && detDefy.reservation && detDefy.reservation.start) {
            const regionId = detDefy.reservation.field?.club?.regionId;
            const countyId = detDefy.reservation.field?.club?.countyId;
            const capacityTeam =
                detDefy.reservation.field?.capacity > 0 ? Math.round(detDefy.reservation.field?.capacity / 2) : '';
            const capacity = ` ${capacityTeam}x${capacityTeam} `;
            if (!(week || region || commune)) {
                const pathnameDefys = `/${sport}/desafiar/equipos/filter?region=${regionId}&commune=${countyId}`;

                setBreads([
                    {
                        key: 'desafiar',
                        name: 'Desafíar | Buscar',
                        url: `/desafiar`,
                        add: true,
                    },
                    {
                        key: 'equipos',
                        name: 'Equipos',
                        url: pathnameDefys,
                        add: false,
                    },
                    {
                        key: 'confirmar',
                        name: 'Confirmar',
                        url: pathnameAll,
                        add: false,
                    },
                ]);
            }
            // format: detDefy.reservation.field.format?.name || '', activar cuando me avisen
            setDateMatch({
                start: format(new Date(detDefy.reservation?.start), "H':'mm"),
                date: format(new Date(detDefy.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detDefy.reservation.end), "H':'mm"),
                format: '',
                club: detDefy.reservation.field.club?.name || '',
            });
            const time: number = Date.parse(detDefy.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeDefy(true);
            } else {
                setTimeDefy(false);
            }
            setDeposit(detDefy.challengePriceTeam);

            if (detDefy?.reservation?.discountPercentage > 0) {
                const total = detDefy.reservation.discountPercentage;
                if (total && total > 0) {
                    setMsj(
                        ` El pago por equipo de este partido es de ${formatPrice(
                            detDefy.challengePriceTeam,
                            0,
                        )}\nPara realizar la reserva debes abonar ${formatPrice(total, 0)}.`,
                    );
                }

                setDeposit(total);
            } else {
                setDeposit(detDefy?.challengePriceTeam);
            }
            if (detDefy && capacity && dataTeamOri) {
                setTitle(
                    `Partido ${capacity} ${
                        teamIdRankingFilter
                            ? dataTeamOri.name
                            : // cuando ambos están disponibles
                            !Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                              !Object.keys(detDefy.challengedTeam).some((x) => x === 'id') &&
                              typeTeam === '1'
                            ? dataTeamOri.name
                            : Object.keys(detDefy.challengerTeam).some((x) => x === 'id')
                            ? detDefy.challengerTeam?.name
                            : !Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                              Object.keys(detDefy.challengedTeam).some((x) => x === 'id')
                            ? dataTeamOri.name
                            : '__'
                    } vs ${
                        teamIdRankingFilter
                            ? teamNameRankingFilter
                            : // cuando ambos están disponibles
                            !Object.keys(detDefy.challengedTeam).some((x) => x === 'id') &&
                              !Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                              typeTeam === '2'
                            ? dataTeamOri.name
                            : Object.keys(detDefy.challengedTeam).some((x) => x === 'id')
                            ? detDefy.challengedTeam?.name
                            : !Object.keys(detDefy.challengedTeam).some((x) => x === 'id') &&
                              Object.keys(detDefy.challengerTeam).some((x) => x === 'id')
                            ? dataTeamOri.name
                            : teamIdRankingFilter != ''
                            ? teamNameRankingFilter
                            : '__'
                    }`,
                );
            }
        }
    }, [detDefy]);

    useEffect(() => {
        if (team) {
            if (team.error) {
                setError('Error al obtener el Equipo del usuario');
            } else {
                if (team.data && team.data.data && team.data.statusCode === 'USER_PROFILE_TEAM_GETED') {
                    const dataTeam = team.data.data;
                    setdataTeamOri(dataTeam);
                    //aqui valido si updateTeamProfile viene en falso no tiene nombre de equipo, se activa el formulario para crearlo
                    if (!dataTeam.updatedTeamProfile) {
                        setOpenModalTeam(true);
                    } else {
                        setOpenModalTeam(false);
                    }
                }
            }
        }
    }, [team]);

    const handlerConfirm = () => {
        setDisabledButtonConfirmDefy(true);
        const directedChallenge = teamIdRankingFilter ? true : false;
        console.log({ detDefy, dataTeamOri });
        const isTeamA =
            detDefy?.challengerTeamId === dataTeamOri?.id ||
            detDefy?.challengerTeamId === '' ||
            detDefy?.challengerTeamId === null;
        console.log({ isTeamA });
        dispatch(
            joinDefy({
                challengeId,
                challengerTeamId: isTeamA ? dataTeamOri?.id : detDefy?.challengerTeamId,
                challengedTeamId: !isTeamA ? dataTeamOri?.id : teamIdRankingFilter,
                directedChallenge,
            }),
        );
    };

    const subTitle = '';

    useEffect(() => {
        setError('');
        dispatch(teamProfileGet(sport));
        if (auth && auth.isLoggedIn && auth.user) {
            setName(auth.user.firstName + ' ' + auth.user.lastName);
            setEmail(auth.user.email);
            setPhone(auth.user.phone ? auth.user.phone : '');
        }
    }, [auth]);

    return (
        <Layout navProps={{ title: 'Inscripción | Supermatch', description: 'Inscripción Supermatch' }}>
            <>
                <Header />
                <LayoutInside attribute={attribute} title={title} subTitle={subTitle} breads={breads}>
                    {defy.isLoading ? (
                        <Loading />
                    ) : detDefy && !statusCancel && errorDefy === '' && !statusDefy ? (
                        !openModalTeam ? (
                            <>
                                {msj && (
                                    <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold whitespace-pre-line">
                                        <p className="w-full text-xl my-6 text-green-500">{msj}</p>
                                    </div>
                                )}
                                <div className="w-full md:w-3/5 lg:w-1/2 mx-auto flex-none md:flex  py-4 md:py-6 md:px-16 border-2 bg-white shadow-lg rounded-xl">
                                    <div className="w-full md:w-2/3 px-4 md:px-0 pb-10 md:pb-0 ">
                                        <PaymentLabels
                                            title="Fecha"
                                            icon="date"
                                            value={`${dateMatch.date}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Desde"
                                            icon="time"
                                            value={`${dateMatch.start} Hrs -  ${dateMatch.end} Hrs`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Cancha"
                                            icon="field"
                                            value={`${
                                                detDefy.fieldRealName
                                                    ? detDefy.fieldRealName
                                                    : detDefy.reservation.field?.name
                                            }`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Lugar"
                                            icon="club"
                                            value={`${detDefy.reservation.field?.club?.name}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Dirección"
                                            icon="location"
                                            value={`${detDefy.reservation.field?.club?.address}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels title="Nombre" icon="user" value={`${name}`} sport={sport} />
                                        <PaymentLabels title="Email" icon="email" value={`${email}`} sport={sport} />
                                        {phone && (
                                            <PaymentLabels title="Teléfono" icon="phone" value={phone} sport={sport} />
                                        )}
                                        {detDefy && detDefy.challengePriceTeam && (
                                            <PaymentLabels
                                                title="Total"
                                                icon="pay"
                                                value={`${formatPrice(detDefy.challengePriceTeam, 0)}`}
                                                sport={sport}
                                            />
                                        )}
                                    </div>
                                    <div className="w-full md:w-2/6 text-center justify-center content-center">
                                        <h3 className="text-xl font-bold italic text-sm-blue-primary pb-4">
                                            {detDefy?.reservation?.discountPercentage > 0
                                                ? 'Abono a pagar por equipo'
                                                : 'Total a pagar por Equipo'}
                                        </h3>

                                        {deposit && (
                                            <div className="flex flex-col text-center justify-center content-center">
                                                <p className="text-4xl pt-4 font-bold italic text-sm-integrate">{`${formatPrice(
                                                    deposit,
                                                    0,
                                                )}`}</p>
                                            </div>
                                        )}
                                        {dataTeamOri && dataTeamOri.updatedTeamProfile && (
                                            <div className="flex flex-col text-center justify-center content-center">
                                                <h3 className="text-2xl font-bold italic text-sm-rent pt-4 pb-4">
                                                    Equipo de {dataTeamOri.sport?.name}:
                                                </h3>
                                                <p className="text-4xl pt-4 font-bold italic text-sm-blue-primary ">
                                                    {dataTeamOri.name}
                                                </p>
                                            </div>
                                        )}
                                        {detDefy.challengerTeam && detDefy.challengerTeam.name && (
                                            <div className="flex flex-col text-center justify-center content-center items-center">
                                                {attribute && (
                                                    <Image
                                                        className="py-8"
                                                        src={attribute.icon.image}
                                                        alt={attribute.alt}
                                                        height={attribute.icon.height}
                                                        width={attribute.icon.width}
                                                    />
                                                )}
                                                <p className="text-4xl pt-4 font-bold italic text-sm-blue-primary ">
                                                    {detDefy.challengerTeam.name}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {!timeDefy &&
                                    (detDefy.challengedStatus !== 'ACCEPTED' ||
                                        detDefy.challengerStatus !== 'ACCEPTED') && (
                                        <div className="flex-col text-center pt-10 pb-5 space-x-8">
                                            <button
                                                className={`bg-sm-integrate  w-1/2 md:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                                type="button"
                                                onClick={() => handlerConfirm()}
                                                disabled={disabledButtonConfirmDefy}
                                            >
                                                Confirmar Desafío
                                            </button>
                                        </div>
                                    )}
                                {detDefy &&
                                    detDefy.challengedStatus === 'ACCEPTED' &&
                                    detDefy.challengerStatus === 'ACCEPTED' && (
                                        <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                            <div className="w-full text-center content-center items-center">
                                                <div
                                                    className={`bg-blue-500  text-white uppercase py-4 font-extrabold`}
                                                >
                                                    Este desafío ya se encuentra confirmado
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {error && (
                                    <div className="flex flex-col mx-auto w-full md:w-1/3 mt-2 mb-2 text-center  font-bold">
                                        <p className="w-full my-6 text-red-500">*{error}</p>
                                    </div>
                                )}
                                <Copy />
                            </>
                        ) : (
                            <FormCreateTeam
                                setOpenModalTeam={setOpenModalTeam}
                                setdataTeamOri={setdataTeamOri}
                                sport={sport}
                                team={team}
                            />
                        )
                    ) : (
                        <>
                            {errorDefy && (
                                <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    <div className="w-full text-center content-center items-center">
                                        <div className={`bg-red-500  text-white uppercase py-4 font-extrabold`}>
                                            * {errorDefy}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {statusDefy && detDefy && detDefy.challengerTeam && dataTeamOri && (
                                <div className="min-h-modal ">
                                    {' '}
                                    <MsjSuccess
                                        challengeId={challengeId}
                                        complete={
                                            (!detDefy?.challengerTeam?.id ||
                                                dataTeamOri?.id === detDefy?.challengerTeam?.id) &&
                                            !detDefy?.challengedTeam?.id
                                                ? false
                                                : true
                                        }
                                    >
                                        <>
                                            <p className="pt-12 text-center text-2xl font-bold italic">
                                                {(!detDefy?.challengerTeam?.id ||
                                                    dataTeamOri?.id === detDefy?.challengerTeam?.id) &&
                                                !detDefy?.challengedTeam?.id
                                                    ? 'Tu Desafío ha sido creado con éxito'
                                                    : 'Tu Desafío ha sido creado con éxito'}
                                            </p>
                                            <p className="">_________________________</p>
                                            <div className="pt-2 px-6 text-center text-xl font-semibold italic ">
                                                {/*  <span className="font-bold  ">{detDefy.challengerTeam.name} </span> */}
                                                {(!detDefy?.challengerTeam?.id ||
                                                    dataTeamOri?.id === detDefy?.challengerTeam?.id) &&
                                                !detDefy?.challengedTeam?.id
                                                    ? teamNameRankingFilter
                                                        ? `Recuerda que todos los partidos suman puntos en el Ranking. Le enviamos un mail 
                                                    a ${teamNameRankingFilter} preguntándole si confirma el desafío. Te avisaremos su 
                                                    respuesta por mail. En caso de que ellos no acepten, te avisaremos y buscaremos 
                                                    otro rival. Cuando el rival este confirmado te avisaremos por mail y te pondremos 
                                                    en contacto con el capitán rival para coordinar los últimos detalles. Asegúrate de 
                                                    tener actualizado el teléfono de contacto en tu perfil.`
                                                        : `Recuerda que todos los partidos suman puntos en el Ranking. Te
                                                    avisaremos por mail cuando el equipo rival este confirmado y te
                                                    pondremos en contacto con el capitán rival para coordinar los últimos
                                                    detalles. Asegúrate de tener actualizado el teléfono de contacto en tu
                                                    perfil.`
                                                    : `Partido confirmado. Recuerda que todos los partidos suman puntos en el Ranking. Te pondremos en contacto con el capitán del equipo rival para coordinar los últimos detalles. Asegúrate de tener actualizado el teléfono de contacto en tu perfil.`}
                                            </div>
                                            <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                                ¡Buen partido!
                                            </p>
                                        </>
                                    </MsjSuccess>
                                </div>
                            )}
                        </>
                    )}
                </LayoutInside>
            </>
        </Layout>
    );
};

export default Challenge;
